import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONSTANTS } from '../../constants';
import { UtilityService } from '../utility.service';
import { Utils } from '../../utils/utils';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    header:any;
    constructor(public httpClient: HttpClient, public utilityService: UtilityService, private utils: Utils) { };
    post(apiUrl: string, requestData: any, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        return this.httpClient.post(base_url + apiUrl, requestData);
    }
    put(apiUrl: string, requestData: any, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        return this.httpClient.put(base_url + apiUrl, requestData);
    }
    get(apiUrl: string, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        return this.httpClient.get(base_url + apiUrl);
    }
    delete(apiUrl: string, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        return this.httpClient.delete(base_url + apiUrl);
    }
    deleteQueryParams(apiUrl: string, queryParams: any, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.delete(base_url + apiUrl, { params });
    }
    contGet(apiUrl: string) {
        return this.httpClient.get(CONSTANTS.API.CONT_BASE_URL + apiUrl);
    }
    orderGet(apiUrl: string) {
        return this.httpClient.get(CONSTANTS.API.ORDER_BASE_URL + apiUrl);
    }
    getQueryParams(apiUrl: string, queryParams: any, base_url: string = "") {
        if (base_url == "") {
            base_url = CONSTANTS.API.BASE_URL;
        }
        if (!this.utils.endsWith(base_url, '/')) {
            base_url = `${base_url}/`;
        }
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.get(base_url + apiUrl, { params });
    }
    getContQueryParams(apiUrl: string, queryParams: any) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.get(CONSTANTS.API.CONT_BASE_URL + apiUrl, { params });
    }
    getOrderQueryParams(apiUrl: string, queryParams: any) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.get(CONSTANTS.API.ORDER_BASE_URL + apiUrl, { params });
    }
    getReportQueryParams(apiUrl: string, queryParams: any) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        // console.log(new Date() + 'Report call start')
        return this.httpClient.get(CONSTANTS.API.REPORT_BASE_URL + apiUrl, { params });
    }
    postOrder(apiUrl: string, requestData: any) {
        return this.httpClient.post(CONSTANTS.API.ORDER_BASE_URL + apiUrl, requestData);
    }
    postReport(apiUrl: string, requestData: any) {
        return this.httpClient.post(CONSTANTS.API.REPORT_BASE_URL + apiUrl, requestData);
    }
    putOrder(apiUrl: string, requestData: any) {
        return this.httpClient.put(CONSTANTS.API.ORDER_BASE_URL + apiUrl, requestData);
    }
    putReport(apiUrl: string, requestData: any) {
        return this.httpClient.put(CONSTANTS.API.REPORT_BASE_URL + apiUrl, requestData);
    }
    deleteOrderQueryParams(apiUrl: string, queryParams: any, data: any = null) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.delete(CONSTANTS.API.ORDER_BASE_URL + apiUrl, { params: params, body: data });
    }
    deleteReportQueryParams(apiUrl: string, queryParams: any, data: any = null) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        return this.httpClient.delete(CONSTANTS.API.REPORT_BASE_URL + apiUrl, { params: params, body: data });
    }
    download(apiUrl: string, queryParams: any) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        this.header = sessionStorage.getItem(CONSTANTS.COOKIE.HEADER_TOKEN);
        return this.httpClient.get(CONSTANTS.API.BASE_URL + apiUrl, {
            responseType: 'blob',
            params: params,
            headers: new HttpHeaders({
                'token': this.header,
            })
        });
    }
    downloadReport(apiUrl: string, queryParams: any) {
        let params = new HttpParams();
        let keys = Object.keys(queryParams);
        for (let i = 0; i < keys.length; i++) {
            params = params.append(keys[i], queryParams[keys[i]]);
        }
        this.header = sessionStorage.getItem(CONSTANTS.COOKIE.HEADER_TOKEN);
        return this.httpClient.get(CONSTANTS.API.REPORT_BASE_URL + apiUrl, {
            responseType: 'blob',
            params: params,
            headers: new HttpHeaders({
                'token': this.header,
            })
        });
    }
}
